import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import Loader from "../components/Layout/Loader";
import ProductCard from "../components/Route/ProductCard/ProductCard";
import styles from "../styles/styles";
import { getAllProducts } from "../redux/actions/product";

const ProductsPage = () => {
  const [searchParams] = useSearchParams();
  const categoryData = searchParams.get("category");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchData, setSearchData] = useState(null);

  const { allProducts, isLoading, totalPages } = useSelector((state) => state.products);

  useEffect(() => {
    dispatch(getAllProducts(currentPage, 30, categoryData));
  }, [dispatch, currentPage, categoryData]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <Header activeHeading={3} setSearchData={setSearchData} />
          <br />
          <br />
          <div className={`${styles.section}`}>
            <div className="grid grid-cols-2 gap-[10px] sm:grid-cols-2 lg:grid-cols-5">
              {(searchData || allProducts).map((product, index) => (
                <ProductCard data={product} key={index} />
              ))}
            </div>
            {(searchData || allProducts).length === 0 && (
              <h1 className="text-center w-full pb-[100px] text-[20px]">
                No products Found!
              </h1>
            )}
            {/* Pagination Controls */}
            {searchData === null && totalPages > 1 && (
              <div className="pagination flex justify-center items-center mt-4">
                <button
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-4 py-2 mx-1 bg-gray-300 rounded disabled:opacity-50"
                >
                  Previous
                </button>
                <span className="mx-2">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 mx-1 bg-gray-300 rounded disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            )}
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default ProductsPage;
